import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Card from '../../../components/Card';

Intent.propTypes = {
  title: PropTypes.node.isRequired,
  selected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};

export default function Intent(props) {
  const {
    title,
    selected,
    onClick
  } = props;

  return (
    <Card
      className={classNames(
        'p-6 cursor-pointer hover:bg-cs-orange-50',
        selected ? 'border-cs-orange-500 border-2 bg-cs-orange-50' : 'border border-cs-gray-300 m-px',
        'flex flex-col sm:flex-row items-start sm:items-center gap-4'
      )}
      onClick={onClick}
    >
      <div className="flex items-center space-x-1">
        <div className="text-lg text-cs-gray-700 font-semiboldx">
          {title}
        </div>
      </div>
    </Card>
  );
};
